import React from "react";
import { useLanguage } from "../../context/LanguageContext";

export default function ChatTabs({ activeTab, setActiveTab, tabs = ["Recent", "Suggested", "Favourites", "Archived"] }) {
  const { t } = useLanguage();

  const tabMap = {
    "Recent": t('dash_recent'),
    "Suggested": t('dash_tab_suggested'), // Mapping to locales keys
    "Favourites": t('dash_favourites'),
    "Archived": t('dash_archived'),
    "Categories": t('nav_wisdom_tab')
  };

  return (
    <div className="flex space-x-2 mb-4 animate-fadeIn overflow-x-auto no-scrollbar pb-1">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-4 py-1.5 text-xs sm:text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 flex-shrink-0
            ${activeTab === tab
              ? "bg-indigo-600 text-white shadow"
              : "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
            }`}
          aria-pressed={activeTab === tab}
        >
          {tabMap[tab] || tab}
        </button>
      ))}
    </div>
  );
}
